import setupAxios from '../../lib/redux/setupAxios'

export const getAllUsers = async (queryParams) => {
    return setupAxios
        .get('/users', {
            params: queryParams,
        })
        .then((res) => res?.data?.data)
}

export const getAllFilteredUsers = async (payload) => {
    return setupAxios
        .post(`/users/filter`, payload)
        .then((res) => res?.data?.data)
}

export const getUserByID = async (id) => {
    return setupAxios.get(`/users/${id}`).then((res) => res?.data?.data[0])
}

export const updateUser = async ({ id, data }) => {
    return setupAxios.post(`/users/${id}`, data).then((res) => res?.data)
}
// Update My Account User
export const updateMyAccountUser = async ({ id, data }) => {
    return setupAxios.post(`/users/update_my_account/${id}`, data).then((res) => res?.data)
}

export const getUserChurchDirectoryLogin = async (payload) => {
    return setupAxios
        .post(`/user_device_tokens/filter`, payload)
        .then((res) => res?.data?.data)
}

export const getCongregationforAdmin = async (payload) => {
    return setupAxios
        .post(`/groups/filter`, payload)
        .then((res) => res?.data?.data)
}

export const getCongregationforWMRC = async ({ id }) => {
    return setupAxios
        .get(`groups/get_groups_wmrc/${id}`)
        .then((res) => res?.data?.data)
}
export const getUserGroupsSelected = async (id, queryParams) => {
    return setupAxios
        .get(`users/get_groups/${id}`, { params: queryParams })
        .then((res) => res?.data?.data)
}

export const getUserGroupsForWMRC = async (id) => {
    return setupAxios
        .get(`users/get_groups/${id}?primary_congregation=Y`)
        .then((res) => res?.data?.data)
}
export const getSelectedTemporaryDivisionByUserId = async (id) => {
    return setupAxios
        .get(`users/get_temp_division/${id}`)
        .then((res) => res?.data?.data)
}
export const getAllTemporaryDivision = async (payload) => {
    return setupAxios
        .post(`/groups/filter`, payload)
        .then((res) => res?.data?.data)
}

export const getDivisionAccessForWMRC = async (userId) => {
    return setupAxios
        .get(`/groups/get_division_access_for_wmrc/${userId}`)
        .then((res) => res?.data?.data)
}

export const getTemporaryDivisionAccess = async (id) => {
    return setupAxios
        .get(`/groups/get_temporary_division_access/${id}`)
        .then((res) => res?.data?.data)
}

// Deduplicate concurrent identical WMRC congregation-type requests (e.g. thunk + WMRCGroupSelect on Edit User).
const wmrcGroupsInFlight = new Map()

export const getAllWMRCGroups = async (queryParams) => {
    const groupId = queryParams?.group_id
    const userId = queryParams?.user_id
    if (groupId == null || groupId === '') {
        return []
    }

    const normalizedUserId = userId == null || userId === '' ? 'nouser' : String(userId)
    const key = `${groupId}:${normalizedUserId}`

    const existing = wmrcGroupsInFlight.get(key)
    if (existing) return existing

    const promise = setupAxios
        .get(`/groups/get_congregation_type/${groupId}`, {
            params:
                userId == null || userId === ''
                    ? undefined
                    : { user_id: userId },
        })
        .then((res) => res?.data?.data)
        .finally(() => {
            wmrcGroupsInFlight.delete(key)
        })

    wmrcGroupsInFlight.set(key, promise)
    return promise
}
export const getCongregationTypesToRelocate = async (id) => {
    return setupAxios
        .get(`/groups/get_congregation_types_to_relocate/${id}`)
        .then((res) => res?.data?.data)
}

export const getCongregationForRelocate = async () => {
    return setupAxios
        .post(`/groups/filter`, {
            ref_group_type_cd: "CONGREGATION",
            order: "desc",
            pagination: "false"
        })
        .then((res) => res?.data?.data)
}
export const saveRelocateData = async ({ id, formData }) => {
    return setupAxios
        .post(`users/relocate_user/${id}`, formData)
        .then((res) => res?.data)
}
export const saveNewUserData = async (payload) => {
    return setupAxios.post('/users', payload).then((res) => res.data)
}
export const deleteUser = async ({ id, payload }) => {
    return setupAxios
        .post(`/users/delete/${id}`, payload)
        .then((res) => res?.data)
}

export const deleteUserChurchDirectoryLogin = async (id) => {
    return setupAxios
        .delete(`/user_device_tokens/${id}`)
        .then((res) => res?.data)
}
export const updateWmrcDivisionUsers = async ({ payload }) => {
    return setupAxios
        .post(`/users/update_congregation_users`, payload)
        .then((res) => res?.data)
}
// email new password request 
export const emailNewPassword = async (id, payload) => {
    return setupAxios
        .post(`/users/email_new_password/${id}`, payload)
        .then((res) => res?.data)
}



export const checkUsernameAvailability = async (username, User_id = null) => {
    const query = User_id
        ? `/users/check_username_availability?username_tx=${username}&User_id=${User_id}`
        : `/users/check_username_availability?username_tx=${username}`

    try {
        const res = await setupAxios.get(query)
        return res?.data
    } catch (error) {
        if (error.response?.data) {
            return error.response.data
        }
        throw error
    }
}


export const getUserSpecificApps = async (data) => {
  const response = await setupAxios.post("app_list_user/filter", data);
  return response.data;
};